// 住所自動入力
// ajaxzip3クラスを付与されたボタンを押すと
// zip2addrに入れた引数のフィールドに住所が入力される
$(document).on('turbolinks:load',function () {
  $('.ajaxzip3').on('click', function(){
    // user_offices#new
    AjaxZip3.zip2addr(
      'user_office[post_code]',
      '',
      'user_office[prefecture]',
      'user_office[address]'
    );


    //失敗時に実行する処理
    AjaxZip3.onFailure = function() {
      alert('郵便番号に該当する住所が見つかりません');
    }; 
    return false;
  });
});
$(document).on('turbolinks:load',function () {
  $('.ajaxzip4').on('click', function(){
    AjaxZip3.zip2addr(
      'client[contact_addresses_attributes][0][post_code]',
      '',
      'client[contact_addresses_attributes][0][prefecture]',
      'client[contact_addresses_attributes][0][address]'
    );
    AjaxZip3.onFailure = function() {
      alert('郵便番号に該当する住所が見つかりません');
    }; 
    return false;
  });
});

$(document).on('turbolinks:load',function () {
  $('.ajaxzip5').on('click', function(){
    // opponents#new
    AjaxZip3.zip2addr(
      'opponent[contact_addresses_attributes][0][post_code]',
      '',
      'opponent[contact_addresses_attributes][0][prefecture]',
      'opponent[contact_addresses_attributes][0][address]'
    );
    AjaxZip3.onFailure = function() {
      alert('郵便番号に該当する住所が見つかりません');
    }; 
    return false;
  });
});

$(document).on('turbolinks:load',function () {
  $('.ajaxzip6').on('click', function(){
    // client_matter_opponents#new
    
    AjaxZip3.onFailure = function() {
      alert('郵便番号に該当する住所が見つかりません');
    }; 
    return false;
  });
});